const { reissEdwards } = window
export default reissEdwards
